import log from 'salvo-lite/log'

class CollectionAdverts {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.textContent)
        this._products = document.querySelectorAll('.boost-pfs-filter-product-item')
        this._count = 0
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._count = this._products.length
        document.addEventListener('collectionUpdate', e => {
            this._products = document.querySelectorAll('.boost-pfs-filter-product-item')
            this._checkAdverts()
        })
    }
    _checkAdverts () {
        this._data.forEach(advert => {
            const position = parseInt(advert.position) - 1
            let prod = []
            const pages = this._products.length / this._count
            for (let i = 0; i < pages; i++) {
                let target = (i * this._count) + position
                prod.push(this._products[target])
            }
            prod.forEach(item => {
                if (item) {
                    if (item.nextElementSibling && item.nextElementSibling.classList.contains('collection__advert')) {
                    } else {
                        let inner = ''
                        let advertHTML = document.createElement('div')
                        advertHTML.classList.add('collection__advert', 'boost-pfs-filter-grid-width-3', 'boost-pfs-filter-grid-width-mb-2')
                        inner = `<a href="${advert.buttonUrl}" class="collection__advert-inner object-cover"><img src="${advert.image}"></a>`
                        advertHTML.innerHTML = inner
                        item.insertAdjacentElement('afterend', advertHTML)
                    }
                }
            })
        })
    }
}

export default CollectionAdverts



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CollectionAdverts.js